import React, { useEffect, useState } from "react";

const SLIDES = [
  {
    img: "https://images.unsplash.com/photo-1733805569204-41768c7d8c0f?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
    title: "Srivari Darshan",
    sub: "Book your Special Entry Darshan to the abode of Lord Venkateswara",
  },
  {
    img: "https://images.unsplash.com/photo-1741003412854-bd4b264c4af3?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
    title: "Arjitha Sevas & Homams",
    sub: "Participate in sacred temple sevas and divine rituals",
  },
  {
    img: "https://images.unsplash.com/photo-1554554497-0095c34db3ec?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
    title: "Accommodation & Donations",
    sub: "Plan a seamless pilgrimage with online accommodation booking",
  },
];

export const HeroCarousel = () => {
  const [i, setI] = useState(0);
  useEffect(() => {
    const t = setInterval(() => setI((p) => (p + 1) % SLIDES.length), 5000);
    return () => clearInterval(t);
  }, []);

  return (
    <div className="relative h-[280px] sm:h-[380px] lg:h-[460px] overflow-hidden" data-testid="hero-carousel">
      {SLIDES.map((s, idx) => (
        <div
          key={idx}
          className={`absolute inset-0 transition-opacity duration-1000 ${idx === i ? "opacity-100" : "opacity-0"}`}
        >
          <img src={s.img} alt={s.title} className="w-full h-full object-cover" />
          <div className="absolute inset-0 bg-gradient-to-r from-[#50000E]/85 via-[#7A0016]/55 to-transparent" />
          <div className="absolute inset-0 flex items-center">
            <div className="max-w-7xl mx-auto px-6 sm:px-10 w-full">
              <div className="max-w-xl">
                <div className="text-xs uppercase tracking-[0.3em] text-[#DAA520] font-bold mb-3">Om Namo Venkatesaya</div>
                <h1 className="font-cinzel text-3xl sm:text-4xl lg:text-5xl font-bold text-amber-50 leading-tight drop-shadow">
                  {s.title}
                </h1>
                <p className="mt-4 text-amber-100/90 text-sm sm:text-base leading-relaxed">{s.sub}</p>
                <a href="#services" className="inline-block mt-6 bg-[#E65100] hover:bg-[#BF360C] text-white font-semibold px-6 py-3 rounded-full transition-colors shadow-lg" data-testid="hero-cta-btn">
                  Explore Pilgrim Services →
                </a>
              </div>
            </div>
          </div>
        </div>
      ))}
      <div className="absolute bottom-5 left-1/2 -translate-x-1/2 flex gap-2 z-10">
        {SLIDES.map((_, idx) => (
          <button
            key={idx}
            onClick={() => setI(idx)}
            className={`h-2 rounded-full transition-all ${idx === i ? "w-8 bg-[#DAA520]" : "w-2 bg-amber-100/60"}`}
            aria-label={`slide ${idx + 1}`}
          />
        ))}
      </div>
    </div>
  );
};
